// StayMii Lite — display-only Net Room Rate (after OTA commission / fees).
// The backend stores the after-commission amount in `net_to_hotel`:
//   - Booking.com: total_price is GROSS, net_to_hotel is the lower real net.
//   - Traveloka:   total_price is ALREADY net; net_to_hotel holds the higher gross.
//   - Others:      net_to_hotel missing / equal / zero -> show total_price.
// Optionally subtracts a per-property Bank Transfer Fee (%) for Booking.com bookings.
// Pure display transform — never touches the DB, taxes/fees, or balance/accounting math.

const isBookingCom = (src) => String(src || '').toLowerCase().includes('booking');

export const netRoomRate = (totalPrice, netToHotel, opts = {}) => {
  const tp = parseFloat(totalPrice);
  const gross = Number.isFinite(tp) ? tp : 0;
  const nth = parseFloat(netToHotel);
  let net = (Number.isFinite(nth) && nth > 0 && nth < gross) ? nth : gross;
  const feePct = parseFloat(opts.bankTransferFeePct);
  if (isBookingCom(opts.bookingSource) && Number.isFinite(feePct) && feePct > 0) {
    net = net * (1 - feePct / 100);
  }
  return net;
};

// Resolves the per-property Bank Transfer Fee % from a { [property_id]: property } map.
export const netRoomRateForBooking = (booking, propertiesById = {}) => {
  if (!booking) return 0;
  const prop = propertiesById[booking.property_id];
  const feePct = prop ? (parseFloat(prop.bank_transfer_fee_pct) || 0) : 0;
  return netRoomRate(booking.total_price, booking.net_to_hotel, {
    bookingSource: booking.booking_source,
    bankTransferFeePct: feePct,
  });
};
